import { Country } from "country-state-city";

/**
 * Fetches, formats, and sorts the list of country codes.
 * Prepend '+' to dial codes if they don't already have one.
 * Sorts alphabetically by country common name.
 */
export const getCountryCodes = () => {
  try {
    return Country.getAllCountries()
      .map((country) => ({
        name: country.name,
        code: country.isoCode,
        dial_code: country.phonecode.startsWith("+") ? country.phonecode : "+" + country.phonecode,
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  } catch (error) {
    console.error("Error formatting country codes:", error);
    return [];
  }
};
